import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { signalsRestApiQueryKeys } from "./key-factory/queryKeyFactory";
import { selectSignalsRestApiStatus } from "./selectSignalsRestApiStatus";

export { DEFAULT_SIGNALS_REST_API_STATUS } from "./types";

export const useSignalsRestApiConfiguredQuery = () => {
    return useQuery({
        refetchOnMount: true,
        queryKey: signalsRestApiQueryKeys.getConfiguredStatus(),
        queryFn: () => salesApiService.signals.fetchSignals(),
        select: selectSignalsRestApiStatus,
    });
};
